import generatorStringCell from './generatorStringCell';

export default (cell: any, index: any, rowIndex: any) => {
  return generatorStringCell(index, cell.value, rowIndex);
};
